import { serverGet, serverPost } from "lib/serverRequest";

export const getSubscriptions = ({ data = {}, onFinish = () => {} }) => {
  serverPost({ url: "subscription", data: data, onFinish: onFinish });
};

export const getOneOffOrders = ({ data = {}, onFinish = () => {} }) => {
  serverPost({ url: "oneofforder", data: data, onFinish: onFinish });
};

export const getSubscriptionDetails = ({
  orderId = "",
  onFinish = () => {},
}) => {
  serverGet({ url: `subscription/${orderId}`, onFinish: onFinish });
};

export const getUserSubscriptions = ({ user_id = "", onFinish = () => {} }) => {
  serverGet({ url: `subscription/boxes/${user_id}`, onFinish: onFinish });
};
